export default __webpack_public_path__ + "static/media/36I-102729_-15735_0.51ce7344.jpg";